
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/airports/news",
      function () {
        return require("private-next-pages/airports/news.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/airports/news"])
      });
    }
  